// JsFromRoutes CacheKey f0e69213b4d0f9dc7eeffeaa0fa52600
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '(/:locale)/search'),
  showGet: /* #__PURE__ */ definePathHelper('get', '/:locale'),
  root: /* #__PURE__ */ definePathHelper('get', '/'),
}
